export const lists_ExcludedMissionKeysAllianceMissions = [
    "only_alliance_mission",
    "filter_id",
    "patient_specialization_ids",
    "patient_specialization_captions",
    "unavailable_in_normal_missions"
]

export const lists_ExcludedMissionKeysAllianceEvents = [
    "filter_id",
    "patient_specialization_ids",
    "patient_specialization_captions",
    "unavailable_in_normal_missions"
]

export const lists_ExcludedMissionKeysMissions = [
    "filter_id",
    "patient_specialization_captions",
    "patient_specialization_ids",
    "duration",
    "patient_allow_first_responder_chance",
    "unavailable_in_normal_missions"
]

export const lists_Codetranslations = [
    {
        "requirements": {
            "firetrucks": {
                "one": "Tankautospuit",
                "more": "Tankautospuiten"
            },
            "platform_trucks": {
                "one": "Redvoertuig",
                "more": "Redvoertuigen"
            },
            "police_cars": {
                "one": "Noodhulpeenheid",
                "more": "Noodhulpeenheden"
            },
            "foam_needed": {
                "one": "Liter SVM",
                "more": "Liters SVM"
            },
            "water_tankers": {
                "one": "Slangenwagen, tankwagen of gelijkwaardige haakarmbak",
                "more": "Slangenwagens, tankwagens of gelijkwaardige haakarmbakken"
            },
            "battalion_chief_vehicles": {
                "one": "Officier van Dienst",
                "more": "Officieren van Dienst"
            },
            "mobile_command_vehicles": {
                "one": "Hoofdofficier van Dienst",
                "more": "Hoofdofficieren van Dienst"
            },
            "mobile_air_vehicles": {
                "one": "Adembeschermingsvoertuig of haakarmbak",
                "more": "Adembeschermingsvoertuigne of haakarmbakken"
            },
            "heavy_rescue_vehicles": {
                "one": "Hulpverleningsvoertuig",
                "more": "Hulpverleningsvoertuigen"
            },
            "elw3": {
                "one": "Commandowagen of haakarmbak",
                "more": "Commandowagens of haakarmbakken"
            },
            "water_needed": {
                "one": "Liter water",
                "more": "Liters water"
            },
            "hazmat_vehicles": {
                "one": "Adviseur gevaarlijke stoffen",
                "more": "Adviseurs gevaarlijke stoffen"
            },
            "gwmess": {
                "one": "Verkenningseenheid",
                "more": "Verkenningseenheden"
            },
            "foam": {
                "one": "Schuimblusvoertuig",
                "more": "Schuimblusvoertuigen"
            },
            "police_horse": {
                "one": "Politie paard",
                "more": "Politie paarden"
            },
            "gefkw": {
                "one": "Dienstbus - Arrestantenvervoer",
                "more": "Dienstbussen - Arrestantenvervoer"
            },
            "grukw": {
                "one": "ME - Flexbus",
                "more": "ME - Flexbussen"
            },
            "lebefkw": {
                "one": "ME - Commandovoertuig",
                "more": "ME - Commandovoertuigen"
            },
            "detention_unit": {
                "one": "ME - Aanhoudingseenheid",
                "more": "ME - Aanhoudingseenheden"
            },
            "hondengeleider": {
                "one": "Hondengeleider",
                "more": "Hondengeleiders"
            },
            "ovdp": {
                "one": "Officier van dienst - Politie",
                "more": "Officieren van dienst - Politie"
            },
            "police_helicopters": {
                "one": "Politiehelikopter",
                "more": "Politiehelikopters"
            },
            "bike_police": {
                "one": "Biketeam",
                "more": "Biketeams"
            },
            "ambulances": {
                "one": "Ambulance",
                "more": "Ambulances"
            },
            "diver_units": {
                "one": "Waterongevallenvoertuig of oppervlaktereddingsvoertuig",
                "more": "Waterongevallenvoertuigen of oppervlaktereddingsvoertuigen"
            },
            "at_o": {
                "one": "AT Operator",
                "more": "AT Operators"
            },
            "at_m": {
                "one": "AT Materiaalwagen",
                "more": "AT Materiaalwagens"
            },
            "at_c": {
                "one": "AT Commandant",
                "more": "AT Commandanten"
            },
            "coastal_boat": {
                "one": "Reddingsboot",
                "more": "Reddingsboten"
            },
            "coastal_guard_boat": {
                "one": "Kustwachtboot",
                "more": "Kustwachtboten"
            },
            "coastal_helicopter": {
                "one": "SAR Helikopter",
                "more": "SAR Helikopters"
            },
            "water_rescue": {
                "one": "Strandvoertuig",
                "more": "Strandvoetuigen"
            },
            "spokesman": {
                "one": "Voorlichter",
                "more": "Voorlichters"
            },
            "boats": {
                "one": "Bootaanhanger",
                "more": "Bootaanhangers"
            },
            "arff": {
                "one": "Crashtender",
                "more": "Crashtenders"
            },
            "elw_airport": {
                "one": "AFO/OSC",
                "more": "AFO's/OSC's"
            },
            "traffic_unit": {
                "one": "Signalisatievoertuig",
                "more": "Signalisatievoertuigen"
            },
            "min_pump_speed": {
                "one": "Minimale pompcapaciteit",
                "more": "Minimale pompcapaciteit"
            },
            "wasserwerfer": {
                "one": "Waterwerper",
                "more": "Waterwerpers"
            },
            "brush_truck": {
                "one": "Terreinvaardige Tankautospuit",
                "more": "Terreinvaardige Tankautospuiten"
            },
            "fire_aviation": {
                "one": "FBO-Heli",
                "more": "FBO-Helikopters"
            },
            "wildfire_equipment": {
                "one": "Natuurbrandbestrijdingsmaterieel",
                "more": "Natuurbrandbestrijdingsmaterieel"
            },
            "wildfire_command": {
                "one": "Landelijk Advieseur Natuurbranden",
                "more": "Landelijk Advieseurs Natuurbranden"
            },
            "search_and_rescue": {
                "one": "Dienstvoertuig USAR",
                "more": "Dienstvoertuigen USAR"
            },
            "disaster_response_equipment": {
                "one": "Hulpverleningsbak - Specialisme Technische Hulpverlening",
                "more": "Hulpverleningsbakken - Specialisme Technische Hulpverlening"
            },
            "disaster_response": {
                "one": "Tankautospuit - Specialisme Technische Hulpverlening",
                "more": "Tankautpspuiten - Specialisme Technische Hulpverlening"
            },
            "rescue_dog_units": {
                "one": "Dienstbus - Speurhonden",
                "more": "Dienstbussen - Speurhonden"
            },
            "search_and_rescue_equipment": {
                "one": "Vrachtwagen USAR",
                "more": "Vrachtwagens USAR"
            },
            "search_and_rescue_engine": {
                "one": "Tankautospuit USAR",
                "more": "Tankautospuiten USAR"
            },
            "police_motorcycle": {
                "one": "Dienstmotor Politie",
                "more": "Dienstmotoren Politie"
            },
            "traffic_patrol": {
                "one": "Snelle Interventievoertuig Politie",
                "more": "Snelle Interventievoertuigen Politie"
            },
            "traffic_inspector": {
                "one": "Dienstbus - Verkeersongevallenanalyse",
                "more": "Dienstbussen - Verkeersongevallenanalyse"
            },
            "mass_casualty_advanced": {
                "one": "Calamiteitenvoertuig GGB",
                "more": "Calamiteitenvoertuigen GGB"
            },
            "mass_casualty": {
                "one": "Noodhulpteam Rode Kruis",
                "more": "Noodhulpteams Rode Kruis"
            }
        },
        "additional": {
            "max_possible_prisoners": "Maximaal aantal gevangenen",
            "min_possible_prisoners": "Minimaal aantal gevangenen",
            "possible_patient": "Maximaal aantal patiënten",
            "possible_patient_min": "Minimaal aantal patiënten",
            "patient_specializations": "Ziekenhuisafdeling(en)",
            "patient_at_end_of_mission": "Patiënten na afronden inzet",
            "allow_rw_instead_of_lf": "Hulpverleningsvoertuig i.p.v. Tankautospuit",
            "expansion_missions_ids": "Kan opschalen naar",
            "allow_ktw_instead_of_rtw": "Zorgambulance i.p.v. Ambulance",
            "need_bike_police_only_if_present": "Bike-team alleen indien in bezit",
            "fire_alarm_system_possible": "OMS/PAC mogelijk",
            "only_alliance_mission": "Alleen Teaminzet",
            "guard_mission": "Geplande inzet",
            "duration_text": "Duur",
            "average_min_fire_personnel": "Benodigd brandweer personeel",
            "subsequent_missions_ids": "Mogelijke vervolginzetten",
            "followup_missions_ids": "Mogelijke verspreidingen",
            "date_end": "Beschikbaar tot",
            "date_start": "Beschikbaar vanaf",
            "followup_mission_only": "Alleen als verspreiding",
            "vehicle_groups": "Voertuiggroepen beschikbaar voor inzet",
            "uses_custom_spawn_area": "Gebruikt eigen inzetgebied",
            "handoff_possible_via_building_types": "Patiënt of gevangenen overdracht via gebouwtype",
            "subsequent_mission_only": "Alleen als vervolginzet",
            "allow_arff_instead_of_lf": "Crashtender i.p.v. Tankautospuit",
            "allow_traffic_car_instead_of_fustw": "Signalisatievoertuig i.p.v. Noodhulp",
            "optional_event_mission": "Uitschakelbare event melding",
            "pump_water_amount": "Aantal liter water weg te pompen",
            "personnel_educations": "Benodigde opgeleide personeelsleden"
        },
        "chances": {
            "patient_transport": "Vervoer kans voor patiënt",
            "nef": "Kans dat het MMT nodig is",
            "platform_trucks": "Kans dat de redvoertuigen benodigd zijn",
            "heavy_rescue_vehicles": "Kans dat de hulpverleningsvoertuigen benodigd zijn",
            "water_tankers": "Kans dat de slangenwagens benodigd zijn",
            "bike_police": "Kans dat de biketeams benodigd zijn",
            "ovdp": "Kans dat de Officiers van Dienst Politie benodigd zijn",
            "mobile_command_vehicles": "Kans dat de Hoofd officieren van Dienst benodigd zijn",
            "mobile_air_vehicles": "Kans dat de Adembeschermingsvoertuigen benodigd zijn",
            "hazmat_vehicles": "Kans dat de Advieseurs gevaarlijke stoffen benodigd zijn",
            "gwmess": "Kans dat de Verkenningseenheden benodigd zijn",
            "elw3": "Kans dat de Commandovoertuigen benodigd zijn",
            "battalion_chief_vehicles": "Kans dat de Officiers van Dienst Brandweer benodigd zijn",
            "diver_units": "Kans dat de waterongevallenvoertuigen benodigd zijn",
            "coastal_helicopter": "Kans dat de SAR Helikopters benodigd zijn",
            "police_horse": "Kans dat de politie paarden benodigd zijn",
            "boats": "Kans dat de bootaanhangers benodigd zijn",
            "arff": "Kans dat de Crashtenders benodigd zijn",
            "elw_airport": "Kans dat de AFO/OSC's benodigd zijn"
        },
        "personnel_educations": {
            "wildfire": "Handcrew",
            "police_motorcycle": "Motoragent"
        }
    }
]

export const lists_EventMissions = [
    {
        "name": "Halloween",
        "mission_ids": [146, 147, 148, 149, 150, 151, 152, 153, 154, 1058, 1059, 1060, 1061],
        "keys": ["all", "halloween"]
    },
    {
        "name": "Sinterklaas",
        "mission_ids": [160, 161, 162, 163, 164, 165, 166, 167, 168, 253],
        "keys": ["all", "sint"]
    },
    {
        "name": "Kerst",
        "mission_ids": [169, 170, 171, 172, 173, 174, 175, 176, 177, 178, 179, 371, 372, 373, 374, 375, 542, 543, 544, 545, 545, 546, 547, 997, 998, 999, 1000, 1072, 1073],
        "keys": ["all", "christmas"]
    },
    {
        "name": "Oud en nieuw",
        "mission_ids": [525, 526, 527, 528, 529, 530, 531, 532, 533, 534, 535, 536, 537, 538, 539, 540, 541, 688, 689, 690, 691, 692, 693, 694, 695, 696, 697, 698, 699, 700, 701, 702, 886],
        "keys": ["all", "newyear"]
    },
    {
        "name": "Valentijn",
        "mission_ids": [562, 563, 727, 728, 729, 730, 731, 732, 733, 734, 735, 1013, 1014, 1015],
        "keys": ["all", "valentine"]
    },
    {
        "name": "Pasen",
        "mission_ids": [578, 579, 580, 581, 582, 583, 584, 585, 586, 587, 588, 935, 936, 937, 938],
        "keys": ["all", "easter"]
    },
    {
        "name": "Zomer",
        "mission_ids": [617, 618, 619, 620, 621, 830, 831, 832,1098,1099,1100,1101,1102],
        "keys": ["all", "seasonal", "summer"]
    },
    {
        "name": "Verjaardag",
        "mission_ids": [736, 737, 738, 739, 740, 741, 742, 743, 744, 745, 746, 747, 748, 749, 750, 751, 752],
        "keys": ["all", "anniversary"]
    },
    {
        "name": "Voetbal",
        "mission_ids": [820, 821, 822, 823, 824, 825, 826, 827, 828, 829, 1083, 1084, 1085, 1086],
        "keys": ["all", "soccer"]
    },
    {
        "name": "Herfst",
        "mission_ids": [856, 857, 858, 859, 860, 861, 862, 863, 864, 865, 1058, 1059, 1060, 1061],
        "keys": ["all", "seasonal", "authum"]
    },
    {
        "name": "112-dag",
        "mission_ids": [902, 903, 904, 905, 906],
        "keys": ["all", "alarmnumber"]
    },
    {
        "name": "Carnaval",
        "mission_ids": [907, 908, 909, 910, 911, 912, 913, 914, 915, 916],
        "keys": ["all", "carnival"]
    },
    {
        "name": "Lente",
        "mission_ids": [920, 921, 922, 923, 924, 925, 926, 927, 928],
        "keys": ["all", "seasonal", "spring"]
    },
    {
        "name": "Winter",
        "mission_ids": [1003, 1004, 1005, 1006, 1074, 1075, 1076, 1077, 1078],
        "keys": ["all", "seasonal", "winter"]
    },
    {
        "name": "Race event",
        "mission_ids": [963, 964, 965, 966, 967, 968, 969, 970, 971, 972, 1048, 1049, 1050, 1051],
        "keys": ["all", "racing"]
    },
    {
        "name": "Moederdag",
        "mission_ids": [788, 789, 790, 791, 792, 793],
        "keys": ["all", "mothersday"]
    },
    {
        "name": "Vaderdag",
        "mission_ids": [1037, 1038, 1039, 1040, 1041],
        "keys": ["all", "fathersday"]
    },
    {
        "name": "Sport event",
        "mission_ids": [1087,1088,1089,1090,1091,1092,1093,1094,1095,1096,1097],
        "keys": ["all", "olympics"]
    }
]

export const lists_EventMissions_filterkeys = [
    {
        "name": "-- Alles",
        "key": "all"
    },
    {
        "name": "Seizoenen",
        "key": "seasonal"
    },
    {
        "name": "Voetbal",
        "key": "soccer"
    },
    {
        "name": "Halloween",
        "key": "halloween"
    },
    {
        "name": "Sinterklaas",
        "key": "sint"
    },
    {
        "name": "Kerst",
        "key": "christmas"
    },
    {
        "name": "Oud en nieuw",
        "key": "newyear"
    },
    {
        "name": "Valentijn",
        "key": "valentine"
    },
    {
        "name": "112-dag",
        "key": "alarmnumber"
    },
    {
        "name": "Carnaval",
        "key": "carnival"
    },
    {
        "name": "Winter",
        "key": "winter"
    },
    {
        "name": "Lente",
        "key": "spring"
    },
    {
        "name": "Herfst",
        "key": "authum"
    },
    {
        "name": "Verjaardag",
        "key": "anniversary"
    },
    {
        "name": "Zomer",
        "key": "summer"
    },
    {
        "name": "Pasen",
        "key": "easter"
    },
    {
        "name": "Race event",
        "key": "racing"
    },
    {
        "name": "Moederdag",
        "key": "mothersday"
    },
    {
        "name": "Vaderdag",
        "key": "fathersday"
    },
    {
        "name": "Olymische spelen",
        "key": "olympics"
    }
]
